import { API } from "aws-amplify";
import { captureSentryMessageForClientProd } from "../common/functions";

// Generic wrapper to handle any GraphQL request
export const callGraphQL = async (
	queryName,
	query,
	variables = {},
	authMode = "AMAZON_COGNITO_USER_POOLS"
) => {
	try {
		const response = await API.graphql({
			query,
			variables,
			authMode
		});
		// Handle case where request "succeeds" but has GraphQL syntax/logic errors
		let apiResponse = response.data[queryName];
		if (apiResponse && typeof apiResponse === "string") {
			try {
				apiResponse = JSON.parse(apiResponse);
			} catch (parseError) {
				console.warn("Failed to parse API response as JSON:", parseError);
			}
		}
		if (
			apiResponse?.statusCode === 400 ||
			apiResponse?.statusCode === 500 ||
			apiResponse?.statusCode === 404
		) {
			captureSentryMessageForClientProd(apiResponse.body, {
				extra: {
					statusCode: apiResponse.statusCode,
					apiResponse: apiResponse.body,
					headers: apiResponse.headers,
					variables: variables,
					query
				}
			});
		}
		return response;
	} catch (error) {
		// Log the specific AppSync error structure if it exists
		const errorDetails = error.errors ? error.errors : error;
		const errorMessage = (Array.isArray(errorDetails) && errorDetails[0]?.message) || error.message || "Unknown error";
		captureSentryMessageForClientProd(errorMessage, {
			extra: {
				errorData: error.data,
				errorDetails: error.errors
			}
		});
		throw error; // Re-throw so the UI component knows it failed
	}
};
